module.exports = __webpack_public_path__ + "static/media/gy.0653b318.svg";